var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { Getter, Mutation, namespace, State } from "vuex-class";
import { LegalCaseManageService } from "~/services/domain-service/legal-case-manage.service";
import CaseMarker from "~/components/common/case-marker.vue";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import Apply from "~/components/visit-case/apply.vue";
import { ApplyType, CASE_CHANNEL, CASE_HALT_CATEGORY, MENU_CHANNEL } from "~/config/enum.config";
import { CaseInfoService } from "~/services/domain-service/case-info.service";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import TeamCaseRepayment from "~/components/visit-case/team-case-repayment.vue";
import TeamCaseBatchRepayment from "~/components/visit-case/team-case-batch-repayment.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
var CollectionExecutionModule = namespace("collection-execution");
var AllotModule = namespace("case-allot");
var LegalTeamCaseManage = /** @class */ (function (_super) {
    __extends(LegalTeamCaseManage, _super);
    function LegalTeamCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.collectionType = "LEGAL";
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            compensationMoney: {
                max: "",
                min: ""
            },
            overdueDays: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            currentCollectorRealName: '',
            partnerName: '',
            batchNumber: '',
            caseMark: ''
        };
        _this.dialog = {
            apply: false,
            ManualDivision: false,
            repayment: false,
            batchRepayment: false
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.applyType = {};
        _this.caseChannel = CASE_CHANNEL.legal;
        _this.otherModel = {
            caseHaltCategory: CASE_HALT_CATEGORY.CASE_HALT
        };
        _this.totalInfo = {};
        _this.teamCaseObj = {};
        _this.selectCaseList = [];
        return _this;
    }
    LegalTeamCaseManage.prototype.mounted = function () {
        this.refreshData();
    };
    LegalTeamCaseManage.prototype.activated = function () {
        this.refreshData();
    };
    LegalTeamCaseManage.prototype.queryTotalInfo = function () {
        var _this = this;
        this.legallyCaseManageServiceTestI
            .teamCasePoolAmount(this.paramsHandler())
            .subscribe(function (data) { return (_this.totalInfo = data); });
    };
    LegalTeamCaseManage.prototype.queryPageInfo = function () {
        var _this = this;
        this.legallyCaseManageServiceTestI
            .teamCasePool(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    LegalTeamCaseManage.prototype.refreshData = function () {
        this.queryTotalInfo();
        this.queryPageInfo();
    };
    LegalTeamCaseManage.prototype.departemntChange = function (id, code) { };
    LegalTeamCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        params.compensationMoneyMax = this.model.compensationMoney ? this.model.compensationMoney.max : "";
        params.compensationMoneyMin = this.model.compensationMoney ? this.model.compensationMoney.min : "";
        params.overdueDaysMax = this.model.overdueDays ? this.model.overdueDays.max : "";
        params.overdueDaysMin = this.model.overdueDays ? this.model.overdueDays.min : "";
        delete params.compensationMoney;
        delete params.overdueDays;
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        return params;
    };
    /**
     * 表单范围输入框重置
     */
    LegalTeamCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
        this.model.personalCollectionRemainingDays = { min: '', max: "" };
        this.model.compensationMoney = { min: "", max: "" };
        this.model.overdueDays = { min: "", max: "" };
    };
    /**
     * 进入查看执行页
     */
    LegalTeamCaseManage.prototype.openExecutionPage = function (row) {
        console.log("[legal-team-case-manage#openExecutionPage:372]:", row);
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Legal_team,
            otherData: {
                data: this.model,
                page: this.pageService,
                sort: this.sortService
            }
        });
    };
    /**
     * 重新分案
     */
    LegalTeamCaseManage.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.id; }));
        this.dialog.ManualDivision = true;
    };
    /**
     * 申请流转
     */
    LegalTeamCaseManage.prototype.applyFlowClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.applyType = ApplyType.turn;
                this.verifySelection();
                return [2 /*return*/];
            });
        });
    };
    /**
     * 申请停催
     */
    LegalTeamCaseManage.prototype.applyPauseClick = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.applyType = ApplyType.pause;
                this.verifySelection();
                return [2 /*return*/];
            });
        });
    };
    LegalTeamCaseManage.prototype.verifySelection = function () {
        if (this.selectionList.length === 0) {
            this.$message("\u8BF7\u9009\u62E9\u8981" + this.applyType.name + "\u7684\u6848\u4EF6");
            return;
        }
        this.dialog.apply = true;
    };
    Object.defineProperty(LegalTeamCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    LegalTeamCaseManage.prototype.onColorChange = function (val) {
        var colorModel = {
            caseIds: this.selectionList.map(function (v) { return v.id; }),
            caseMark: val
        };
        this.caseInfoService
            .caseInfoMarkColor(colorModel)
            .subscribe(this.refreshData);
    };
    /**
     * 还款
     */
    LegalTeamCaseManage.prototype.repaymentClick = function (row) {
        this.dialog.repayment = true;
        this.teamCaseObj = row;
    };
    /**
     * 批量还款
     */
    LegalTeamCaseManage.prototype.batchRepaymentClick = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.batchRepayment = true;
            this.selectCaseList = this.selectionList;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u6279\u91CF\u8FD8\u6B3E\u7684\u6848\u4EF6");
        }
    };
    /**
     * 批量还款弹窗关闭回调
     */
    LegalTeamCaseManage.prototype.dialogClose = function () {
        this.refreshData();
        this.dialog.batchRepayment = false;
        this.selectionList = [];
    };
    __decorate([
        Dependencies(PageService)
    ], LegalTeamCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], LegalTeamCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(LegalCaseManageService)
    ], LegalTeamCaseManage.prototype, "legallyCaseManageServiceTestI", void 0);
    __decorate([
        Dependencies(CaseInfoService)
    ], LegalTeamCaseManage.prototype, "caseInfoService", void 0);
    __decorate([
        Mutation
    ], LegalTeamCaseManage.prototype, "updateCollectionType", void 0);
    __decorate([
        Getter
    ], LegalTeamCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        AllotModule.Mutation
    ], LegalTeamCaseManage.prototype, "updateCaseIds", void 0);
    __decorate([
        State
    ], LegalTeamCaseManage.prototype, "principalList", void 0);
    LegalTeamCaseManage = __decorate([
        Auth(303),
        Layout("workspace"),
        Component({
            components: {
                GetLabelName: GetLabelName,
                NumberRange: NumberRange,
                CaseMarker: CaseMarker,
                CaseAllot: CaseAllot,
                Apply: Apply,
                TeamCaseRepayment: TeamCaseRepayment,
                TeamCaseBatchRepayment: TeamCaseBatchRepayment,
                SelectDepartment: SelectDepartment
            }
        })
    ], LegalTeamCaseManage);
    return LegalTeamCaseManage;
}(Vue));
export default LegalTeamCaseManage;
